/*
 * Localised dashboard screenshots for the marketing pages.
 * Generated per language by scripts/demo_shots/shoot_site.py → public/screens/v2/{name}-{lang}.webp
 */
const SHOT_LANGS = ['nl', 'en', 'fr', 'de', 'es', 'zh'];

export const shotUrl = (name, lang) => `/screens/v2/${name}-${SHOT_LANGS.includes(lang) ? lang : 'en'}.webp`;

/* Legacy static (Dutch-only) mock-ups that the built-in defaults, or older saved admin content, may still point at. */
const LEGACY = {
  '/brand/hero-screen.png': 'overzicht',
  '/brand/shot-financieel.png': 'financieel',
  '/brand/shot-verkopen.png': 'verkopen',
  '/brand/shot-producten.png': 'producten',
  '/brand/shot-prijsradar.png': 'prijsradar',
  '/brand/feat-shot-overzicht.png': 'overzicht',
  '/brand/feat-shot-verkopen.png': 'verkopen',
  '/brand/feat-shot-financieel.png': 'financieel',
  '/brand/feat-shot-producten.png': 'producten',
  '/brand/feat-shot-ai.png': 'ai',
};

/* Deep-swap legacy screenshot paths for the current language's screenshot. */
export const localizeShots = (node, lang) => {
  if (Array.isArray(node)) return node.map((n) => localizeShots(n, lang));
  if (node && typeof node === 'object') {
    const out = {};
    Object.keys(node).forEach((k) => {
      const v = node[k];
      out[k] = k === 'image_url' && LEGACY[v] ? shotUrl(LEGACY[v], lang) : localizeShots(v, lang);
    });
    return out;
  }
  return node;
};

/* Responsive variants (640 / 1280 px next to the 2560 px original) generated by scripts/demo_shots/shoot_site.py */
export const shotSrcSet = (url) =>
  /\/screens\/v2\/.+-[a-z]{2}\.webp$/.test(url || '')
    ? `${url.replace('.webp', '-640.webp')} 640w, ${url.replace('.webp', '-1280.webp')} 1280w, ${url} 2560w`
    : undefined;
